module.exports = __webpack_public_path__ + "static/media/1001396.b379989f.png";